/***
 * rfm标准分析
 */
import { post,get,postJson,put} from '../axios'
const RESOURCE_BASE_PATH = '/rfm-analyse'

//GET /rfm-analyse/standard
// 获取RFM标准分析
export const  RFM_Standard_Analyse = p => get(`${RESOURCE_BASE_PATH}/standard`, p)

// 获取RFM自定义分析
export const  RFM_Customize_Analyse = p => get(`${RESOURCE_BASE_PATH}/customize`, p)

// 消费客户
export const  queryByNumChange = p => get(`${RESOURCE_BASE_PATH}/customizeByCondition`, p)

//客户画像
export const  portrait = p => get(`${RESOURCE_BASE_PATH}/analyze/portrait`, p)

// 获取RF分析
export const  RF_Standard_Ana = p => get(`${RESOURCE_BASE_PATH}/rf/analyse`, p)

// 获取RF分析
export const  saveCrowd = p => postJson(`${RESOURCE_BASE_PATH}/rf/saveCrowd`, p)

// 获取流失客户
export const  lostCustomer = p => get(`${RESOURCE_BASE_PATH}/outFlow`, p)

// 查询配置条件 
export const getAnalyse = p => get(`/rfm-analyse/config`, p)

// 新增/修改配置
export const  analyseconfig = p => postJson(`/rfm-analyse/config/`, p)

// 导出数据 
export const exportData = p => get(`/rfm-analyse/customize/export`, p)

// 导出数据--自营
export const selfExportData = p => get(`/rfm-analyse/shop/export`, p)

//导出数据
export const exportNum = p => get(`/rfm-analyse/analyze/portrait/export`, p)

//rfm分析导出数据
export const rfmExport = p => get(`/rfm-analyse/export`, p)